import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import './fair-interactive-map-floor-selector.css';

function FairInteractiveMapFloorSelector({ data, value, onChange }) {
  const selectRef = useRef(null);

  const handleSelectChange = useCallback((e) => {
    const newValue = e.target.value;
    if (newValue === 'none') {
      onChange(null);
    } else {
      onChange(newValue);
    }
  }, [onChange]);

  useEffect(() => {
    const selectRefCurrent = selectRef.current;
    if (!selectRefCurrent) {
      return () => {};
    }

    window.jcf.replace(selectRefCurrent);

    return () => {
      window.jcf.destroy(selectRefCurrent);
    };
  }, []);

  useEffect(() => {
    if (selectRef.current) {
      window.jcf.refresh(selectRef.current);
    }
  });

  if (data.length === 0) {
    return null;
  }

  return (
    <div className="fair-interactive-map-floor-selector">
      <select
        ref={selectRef}
        value={value || ''}
        data-jcf={JSON.stringify({
          wrapNative: false,
          wrapNativeOnMobile: false,
        })}
        onChange={handleSelectChange}
      >
        <option className="hide">Select floor</option>
        {value && (
          <option value="none">Show all</option>
        )}
        {data.map((item) => (
          <option key={item} value={item}>{item}</option>
        ))}
      </select>
    </div>
  );
}

export { FairInteractiveMapFloorSelector };

FairInteractiveMapFloorSelector.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

FairInteractiveMapFloorSelector.defaultProps = {
  value: '',
};
